// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f27f9763","453":"1c484409"}[chunkId] + ".chunk.js";
};